import { UAParser } from 'ua-parser-js'

let parser: UAParser | null = null

export const getUAParser = (): UAParser => {
	if (!parser) {
		parser = new UAParser()
	}
	return parser
}
